import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [content, setContent] = useState({});

  const load = useCallback(async () => {
    try {
      const [cfg, cnt] = await Promise.all([
        api.get("/public/config"),
        api.get("/public/content"),
      ]);
      setConfig(cfg.data);
      setContent(cnt.data || {});
    } catch {
      setConfig({ settings: {}, pricing: null, delivery_methods: [] });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = {
    config,
    content,
    settings: config?.settings || {},
    pricing: config?.pricing || null,
    deliveryMethods: config?.delivery_methods || [],
    refresh: load,
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) || { settings: {}, content: {}, pricing: null, deliveryMethods: [] };
